module.exports = __webpack_public_path__ + "background28.jpg?f18dfcc7fded31f221f9f4708fc15c06";